<template>
  <div class="irc irc-hidden" ref="irc">
    <div class="irc__inner-container">
      <iframe
        width="100%"
        frameborder="0"
        border="0"
        marginwidth="0"
        marginheight="0"
        scrolling="default"
        src="https://irc.soundcamp.radio?backgroundcolor=black&primarycolor=white&nickcolors=manual&nickcolorscheme=reveil2025"
      ></iframe><span class="irc__instructions">To change your username, type in chat: /nick YourName. You can specify a <a href="https://soundtent.org/reveil_platform_2026/color_codes">color code</a> for your surroundings in brackets.<br></span>
      <!-- https://irc.soundtent.org/?v=1&theme=soundcamp_irc_v2_black#acousticommons -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'IRC',
  props: [],
  mounted() {
    var streamInfo;
    var irc = $(this.$refs['irc']);
    var ircHidden = null;
    var chat;
    var streamInfo;

    $(window).on("scroll resize",function(){
      if (window.innerWidth > window.innerHeight && window.innerWidth>=800) {
        if (!chat || chat.length==0) {chat = $('.chat-label'); }
        if (!streamInfo || streamInfo.length==0) {streamInfo = $('.stream-info__description');}
        
        var ircTop = irc.offset().top;


        if (streamInfo.length==0) {
          var scroller = $('.scroller');
          var streamInfoBottom = scroller.offset().top + scroller.height();
        }
        else {
          var streamInfoBottom = streamInfo.offset().top + streamInfo.height();
        }

        if (ircTop > streamInfoBottom && (ircHidden == true || ircHidden == null) ) {
          ircHidden = false;
          irc.removeClass("irc-hidden");
          chat.addClass("hidden");
        }
        else if (ircTop <= streamInfoBottom && (ircHidden == false || ircHidden == null) ) {
          ircHidden = true;
          irc.addClass("irc-hidden");
          chat.removeClass("hidden");
        }
      }
    });
  },
  unmounted() {
    $(window).off("scroll");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/IRC.vue